import { createSentryConfig, sharedEnvironment } from './shared-environment'

export const environment = {
  ...sharedEnvironment,
  production: false,
  isApp: true,
  domain: 'https://productfeedbackquality.calzedonia.com',
  keycloakUrl: 'https://keycloak.dev.gcp.calzedonia.com',
  oktaRedirect: 'https://productfeedbackquality.calzedonia.com/auth/realms/quake/broker/samloktapf/endpoint',
  redirectUri: 'https://productfeedbackquality.calzedonia.com',
  version: '4.0.0',
  name: 'QA ENVIRONMENT',
  minName: 'QA ENVIRONMENT',
  sentryName: 'QA',
  sentry: createSentryConfig(0.5, ['error']),
}
